import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, CalendarHeart } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
import { Logo } from "./Logo";

export const NAV = [
  { to: "/", label: "Ana Sayfa", end: true },
  { to: "/kurslar", label: "Kurslar" },
  { to: "/ogretmenler", label: "Öğretmenler" },
  { to: "/galeri", label: "Galeri" },
  { to: "/etkinlikler", label: "Etkinlikler" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/iletisim", label: "İletişim" },
];

const linkCls = ({ isActive }) =>
  `px-3 py-2 rounded-full text-[15px] font-semibold transition-colors duration-200 ${
    isActive ? "bg-bej text-navy" : "text-navy/80 hover:text-navy hover:bg-bej-light"
  }`;

export const BookButton = ({ className = "", testid = "header-book-btn", children = "Randevu Al" }) => (
  <Link
    to="/randevu"
    data-testid={testid}
    className={`inline-flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-white font-heading font-bold shadow-lg shadow-navy/20 transition-[background-color,transform] duration-200 hover:bg-navy-dark hover:-translate-y-0.5 active:translate-y-0 ${className}`}
  >
    <CalendarHeart className="w-4 h-4" />
    {children}
  </Link>
);

export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-xl border-b border-bej/70">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className={linkCls} data-testid={`nav-${n.to.replace("/", "") || "home"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <BookButton className="hidden sm:inline-flex" />
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="lg:hidden p-2.5 rounded-full bg-bej text-navy" data-testid="mobile-menu-btn" aria-label="Menü">
                <Menu className="w-5 h-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-cream w-[85vw] max-w-sm">
              <SheetTitle className="sr-only">Menü</SheetTitle>
              <div className="mt-8 flex flex-col gap-1">
                {NAV.map((n) => (
                  <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} className={linkCls}
                    data-testid={`mobile-nav-${n.to.replace("/", "") || "home"}`}>
                    {n.label}
                  </NavLink>
                ))}
                <div className="mt-6" onClick={() => setOpen(false)}>
                  <BookButton testid="mobile-book-btn" className="w-full justify-center py-3" />
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
